import React from 'react';
import useValidateImportFormTableRow, {
    VALIDATION_ERRORS
} from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/components/ValidateImportFormTableRow/hooks/useValidateImportFormTableRow";
import {PolIcon} from "components/PolIcon/policon";
import ReactTooltip from "react-tooltip";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function ValidateImportFormTableRow({headers, rowData, index}) {
    const {t} = usePolTranslation();
    const {
        validationErrors,
    } = useValidateImportFormTableRow(rowData, index);

    return (
        <tr className={validationErrors.length ? 'import-table__row--error' : 'import-table__row--valid'}>
            <td>
                {validationErrors.length > 0 && (
                    <>
                        <span data-for={`error-${index}`}
                              data-tip={`<ul>
                                ${validationErrors.map(({header, message}) => {
                                  return `<li><strong>${t(header)}:</strong> ${t(message)}</li>`
                              }).join('')}
                                </ul>`}>
                            <PolIcon icon="exclamation-circle" className="import-table__row__icon"/>
                        </span>
                        <ReactTooltip effect="solid" place="right" id={`error-${index}`} delayHide={200} html clickable/>
                    </>
                )}
            </td>
            {removeErrorHeader(headers).map(header => {
                const key = typeof header === 'object' ? header.key : header;
                return (
                    <td key={key}>{rowData?.[key]}</td>
                )
            })}
        </tr>
    )
}

export function removeErrorHeader(headers) {
    return headers.filter(header => {
        const key = typeof header === 'object' ? header.key : header;
        return key !== VALIDATION_ERRORS;
    });
}
